

<nav class="navbar-custom navbar navbar-expand-lg">
  <div class="container-fluid tpo-mobile-menu-container-style">
    <a class="navbar-brand" href="#">
      <img [src]="companyLogoUrl" alt="Company Logo" class="me-1 tpo-header-logo">
    </a>
    <button class="nav-link button-menu-mobile d-none-non-mobile tpo-mobile-menu-toggle" type="button" data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent2" aria-controls="navbarSupportedContent" aria-expanded="false"
      aria-label="Toggle navigation">
      <i class="fa-solid fa-bars align-self-center topbar-icon topbar-icon-mobile tpo-topbar-icon-mobile"
      style="color: #d84d38!important;"></i>
    </button>
    @if (currentlyLoggedInUser) {
      <div class="dropdown d-none-non-mobile tpo-mobile-profile-trigger">
        <a class="nav-link dropdown-toggle nav-user tpo-mobile-profile-link" data-bs-toggle="dropdown" href="#"
          role="button" aria-haspopup="false" aria-expanded="false">
          <img [src]="userAvatarUrl" alt="profile-user" class="rounded-circle thumb-xs" />
          <span class="nav-user-name">{{currentlyLoggedInUserProfile.firstName}}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-end">
          <a class="dropdown-item classic-dropdown-item-padding font-14" [routerLink]="['/tpo/profile']">
            <i class="pi pi-user align-self-center me-1"></i> Profile
          </a>
          <a class="dropdown-item classic-dropdown-item-padding font-14" [routerLink]="['/tpo/settings']">
            <i class="pi pi-cog align-self-center me-1"></i> Settings
          </a>
          <div class="dropdown-divider mb-1 mt-1"></div>
          @if (currentUserIsPrimaryRoleUser && wizardUrls.length === 1 && isOnlineAppEnabled) {
            <a class="dropdown-item classic-dropdown-item-padding font-14" (click)="copyLink(wizardUrls[0])">
              <i class="pi pi-chart-line align-self-center me-1"></i>
              Online App Link
            </a>
            <div class="dropdown-divider mb-1 mt-1"></div>
          }
          <div class="dropdown-divider mb-0"></div>
          <a class="dropdown-item classic-dropdown-item-padding font-14" (click)="onLogoutClicked()">
            <i class="pi pi-power-off align-self-center me-1"></i> Logout
          </a>
          @if (version) {
            <div class="dropdown-divider mt-1"></div>
            <span class="dropdown-item font-12 text-muted">Version: {{version}}</span>
          }
        </div>
      </div>
    }

    <div class="collapse navbar-collapse tpo-mobile-menu-style justify-content-between d-none-mobile">

      <ul class="list-unstyled d-flex topbar-nav mb-0">
        @if (isNewApplicationEnabled) {
          <li class="nav-item">
            <a class="nav-link  " [routerLink]="['/tpo/new-application']">
              <i class="fas fa-plus caret-style"></i> New Application
            </a>
          </li>
        }
        <li class="nav-item">
          <a class="nav-link  " aria-current="page" [routerLink]="['/tpo/dashboard']"> Dashboard
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link  " aria-current="page" [routerLink]="['/tpo/pipeline']"> Pipeline
          </a>
        </li>
        @if (isCompanyDeepHaven) {
          <li class="nav-item">
            <a class="nav-link  " aria-current="page"
              [href]="'https://heloc.deephavenmortgage.com'" target="_blank" rel="noopener noreferrer"> Submit HELOC
            </a>
          </li>
        }
        <li class="nav-item" [hidden]="!applicationContext.userPermissions.pricingEnabled || !hasPpeAccess()">
          <a class="nav-link waves-effect waves-light" aria-current="page" [routerLink]="['/tpo/quick-pricer']">
          Quick Pricer </a>
        </li>
        @if (applicationContext.isCompanyPRMG && !isApprisalDisabled) {
          <li class="nav-item">
            <a class="nav-link  " aria-current="page" [routerLink]="['/tpo/appraisal-management']">
            Appraisal Management </a>
          </li>
        }
        <li class="dropdown">
          <a class="nav-link dropdown-toggle  " data-bs-toggle="dropdown" href="#" role="button"
            aria-haspopup="false" aria-expanded="false">
            <span>Recent Apps <i class="fas fa-angle-down caret-style"></i></span>
          </a>
          <ul class="dropdown-menu dropdown-menu-end">
            @for (app of recentApps; track app.applicationId) {
              <a class="dropdown-item recent-app-item" style="cursor:pointer;"
                [routerLink]="['/tpo/app-details/' + app.applicationId]">
                <i class="fas fa-file-invoice me-2"></i>
                <span class="recent-app-text">{{app.displayText}}</span>
              </a>
            }
          </ul>
        </li>
        @if (isSupportTicketingEnabled) {
          <li class="nav-item">
            <a class="nav-link" aria-current="page" [routerLink]="['/tpo/support']">{{brokerSupportPageTitle}}</a>
          </li>
        }
        <li class="nav-item" [hidden]="!isCompanySmartfi">
          <a class="nav-link  " aria-current="page" href="https://www.smartfihomeloans.com/wholesale/partner-resources/" target="_blank">
          Resources </a>
        </li>
        @if (resourceLinks.length > 0) {
          <li class="dropdown">
            <a class="nav-link dropdown-toggle  " data-bs-toggle="dropdown" href="#" role="button"
              aria-haspopup="false" aria-expanded="false">
              <span id="resource-link">Resources <i class="fas fa-angle-down caret-style"></i></span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              @for (rl of resourceLinks; track rl.displayText) {
                <li>
                  @if (rl.url) {
                    <a class="dropdown-item" style="cursor:pointer;min-height: 20px;line-height: 20px;"
                      href="{{rl.url || ''}}" target="_blank">
                      {{rl.displayText}}
                    </a>
                  }
                  @if (rl.routerLink) {
                    <a class="dropdown-item" style="cursor:pointer;min-height: 20px;line-height: 20px;"
                      [routerLink]="[rl.routerLink]">
                      {{rl.displayText}}
                    </a>
                  }
                </li>
              }
            </ul>
          </li>
        }
        @if (isCompanyDeepHaven) {
          <li class="nav-item">
            <a class="nav-link  " aria-current="page"
              [href]="'https://www.youtube.com/playlist?list=PLUiFrS9Dr-b0b5hEU-i6yNpdkqDAqU132'" target="_blank" rel="noopener noreferrer"> Training Videos
            </a>
          </li>
        }
      </ul>
      <ul class="list-unstyled d-flex topbar-nav mb-0 me-3">
        <li class="dropdown hide-phone">

        </li>

        <li class="dropdown" style="border-left: 1px solid #e3ebf6;">
          <a class="nav-link arrow-none show" (click)="showNotifications()" role="button">
            <i class="pi pi-bell badge-notify"></i>
            @if (alertsAndNotifications.totalAlertCount) {
              <span class="position-absolute badge bg-danger rounded-pill noti-icon-badge"
                >{{alertsAndNotifications.totalAlertCount > 99 ? '+99' :
              alertsAndNotifications.totalAlertCount}}</span>
            }
          </a>
        </li>

        <li class="dropdown" style="border-right: 1px solid #e3ebf6;">
          <a class="nav-link arrow-none  show" (click)="showMentions()" role="button">
            <i class="pi pi-at badge-notify"></i>
            @if (unreadMentionCount > 0) {
              <span class="position-absolute badge bg-danger rounded-pill noti-icon-badge">
                {{unreadMentionCount >= 200 ? '+200' : unreadMentionCount}}
              </span>
            }
          </a>
        </li>

        @if (currentlyLoggedInUser) {
          <li class="dropdown">
            <a class="nav-link dropdown-toggle   nav-user" data-bs-toggle="dropdown" href="#"
              role="button" aria-haspopup="false" aria-expanded="false">
              <span class="ms-1 nav-user-name pe-2">{{currentlyLoggedInUserProfile.firstName}}
              </span>
              <img [src]="userAvatarUrl" alt="profile-user" class="rounded-circle thumb-xs" />
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <a class="dropdown-item classic-dropdown-item-padding font-14" [routerLink]="['/tpo/profile']">
                 <i class="pi pi-user align-self-center me-1"></i> Profile
              </a>
              <a class="dropdown-item classic-dropdown-item-padding font-14" [routerLink]="['/tpo/settings']">
                <i class="pi pi-cog align-self-center me-1"></i> Settings
              </a>
              <a class="dropdown-item classic-dropdown-item-padding font-14" [routerLink]="['/tpo/change-password']">
                <i class="pi pi-lock align-self-center me-1"></i> Change Password
              </a>
              <div class="dropdown-divider mb-1 mt-1"></div>
              @if (currentUserIsPrimaryRoleUser && wizardUrls.length === 1 && isOnlineAppEnabled) {
                <a class="dropdown-item classic-dropdown-item-padding font-14" (click)="copyLink(wizardUrls[0])">
                  <i class="pi pi-chart-line align-self-center me-1"></i>
                  Online App Link
                </a>
                <div class="dropdown-divider mb-1 mt-1"></div>
              }
              <a class="dropdown-item classic-dropdown-item-padding font-14" (click)="onLogoutClicked()">
                <i class="pi pi-power-off align-self-center me-1"></i> Logout
              </a>
              @if (version) {
                <div class="dropdown-divider mt-1"></div>
                <span class="dropdown-item font-12 text-muted">Version: {{version}}</span>
              }
            </div>
          </li>
        }
      </ul>
    </div>

    <div class="d-none-non-mobile flex-line-break"></div>

    <div class="collapse navbar-collapse d-none-non-mobile tpo-mobile-collapse" id="navbarSupportedContent2">

      <div class="tpo-mobile-menu-panel">
      <ul class="list-unstyled d-flex topbar-nav mb-0 h-auto tpo-mobile-menu-style tpo-mobile-menu-list">
        <li class="dropdown hide-phone">

        </li>

        <li class="dropdown tpo-mobile-menu-item tpo-mobile-menu-item--utility tpo-mobile-menu-item--utility-half">
          <a class="nav-link arrow-none show tpo-mobile-menu-link tpo-mobile-menu-link--icon tpo-mobile-menu-link--utility" (click)="showNotifications()" role="button">
            <span class="tpo-mobile-menu-icon-wrap">
              <i class="pi pi-bell badge-notify"></i>
              @if (alertsAndNotifications.totalAlertCount) {
                <span class="position-absolute badge bg-danger rounded-pill noti-icon-badge"
                  >{{alertsAndNotifications.totalAlertCount > 99 ? '+99' :
                alertsAndNotifications.totalAlertCount}}</span>
              }
            </span>
            <span class="tpo-mobile-menu-link__label">Notifications</span>
          </a>
        </li>

        <li class="dropdown tpo-mobile-menu-item tpo-mobile-menu-item--utility tpo-mobile-menu-item--utility-half">
          <a class="nav-link arrow-none show tpo-mobile-menu-link tpo-mobile-menu-link--icon tpo-mobile-menu-link--utility" (click)="showMentions()" role="button">
            <span class="tpo-mobile-menu-icon-wrap">
              <i class="pi pi-at"></i>
              @if (unreadMentionCount > 0) {
                <span class="position-absolute badge bg-danger rounded-pill noti-icon-badge">
                  {{unreadMentionCount >= 200 ? '+200' : unreadMentionCount}}
                </span>
              }
            </span>
            <span class="tpo-mobile-menu-link__label">Mentions</span>
          </a>
        </li>

        <li class="dropdown-divider tpo-mobile-divider"></li>
        @if (isNewApplicationEnabled || isNewLeadReferralEnabled) {
          <li class="dropdown tpo-mobile-menu-item">
            <a class="nav-link dropdown-toggle tpo-mobile-menu-link" data-bs-toggle="dropdown" href="#" role="button"
              aria-haspopup="false" aria-expanded="false">
              <span class="tpo-mobile-inline-group"><i-lucide name="plus" [size]="16" [strokeWidth]="2.4" class="tpo-mobile-inline-lucide"></i-lucide><span>New</span></span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              @if (isNewApplicationEnabled) {
                <a class="dropdown-item" style="cursor:pointer;"
                  [routerLink]="['/tpo/new-application']">
                  <i class="far fa-flag mx-1"></i> New Application
                </a>
              }
              @if (isNewLeadReferralEnabled) {
                <a class="dropdown-item" style="cursor:pointer;"
                  [routerLink]="['/tpo/new-lead-referral']">
                  <i class="fas fa-university mx-1"></i> New Lead Referral
                </a>
              }
            </ul>
          </li>
        }
        <li class="dropdown-divider tpo-mobile-divider"></li>
        <li class="nav-item tpo-mobile-menu-item">
          <a class="nav-link tpo-mobile-menu-link" aria-current="page" [routerLink]="['/tpo/dashboard']"> Dashboard
          </a>
        </li>
        <li class="dropdown-divider tpo-mobile-divider"></li>
        <li class="nav-item tpo-mobile-menu-item">
          <a class="nav-link tpo-mobile-menu-link" aria-current="page" [routerLink]="['/tpo/pipeline']"> Pipeline
          </a>
        </li>
        <li class="dropdown-divider tpo-mobile-divider"></li>
        <li class="nav-item tpo-mobile-menu-item" [hidden]="!applicationContext.userPermissions.pricingEnabled || !hasPpeAccess()">
          <a class="nav-link waves-effect waves-light tpo-mobile-menu-link" aria-current="page" [routerLink]="['/tpo/quick-pricer']">
          Quick Pricer </a>
        </li>
        @if (applicationContext.isCompanyPRMG) {
          <li class="nav-item tpo-mobile-menu-item">
            <a class="nav-link tpo-mobile-menu-link" aria-current="page" [routerLink]="['/tpo/appraisal-management']">
            Appraisal Management </a>
          </li>
        }
        <li class="dropdown-divider tpo-mobile-divider"></li>
        <li class="dropdown tpo-mobile-menu-item">
          <a class="nav-link dropdown-toggle tpo-mobile-menu-link" data-bs-toggle="dropdown" href="#" role="button"
            aria-haspopup="false" aria-expanded="false">
            <span class="tpo-mobile-inline-group"><i-lucide name="chevron-down" [size]="16" [strokeWidth]="2.4" class="tpo-mobile-inline-lucide tpo-mobile-inline-lucide--chevron"></i-lucide><span>Recent Apps</span></span>
          </a>
          <ul class="dropdown-menu dropdown-menu-end">
            @for (app of recentApps; track app.applicationId) {
              <a class="dropdown-item recent-app-item" style="cursor:pointer;"
                [routerLink]="['/tpo/app-details/' + app.applicationId]">
                <i class="fas fa-file-invoice me-2"></i>
                <span class="recent-app-text">{{app.displayText}}</span>
              </a>
            }
          </ul>
        </li>
        @if (isSupportTicketingEnabled) {
          <li class="nav-item tpo-mobile-menu-item">
            <a class="nav-link tpo-mobile-menu-link" aria-current="page" [routerLink]="['/tpo/support']">{{brokerSupportPageTitle}}</a>
          </li>
        }
        <li class="nav-item tpo-mobile-menu-item" [hidden]="!isCompanySmartfi">
          <a class="nav-link tpo-mobile-menu-link" aria-current="page" href="https://www.smartfihomeloans.com/wholesale/partner-resources/" target="_blank">
          Resources </a>
        </li>
        @if (resourceLinks.length > 0) {
          <li class="dropdown tpo-mobile-menu-item">
            <a class="nav-link dropdown-toggle tpo-mobile-menu-link" data-bs-toggle="dropdown" href="#" role="button"
              aria-haspopup="false" aria-expanded="false">
              <span id="resource-link">Resources <i class="fas fa-angle-down caret-style"></i></span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              @for (rl of resourceLinks; track rl.displayText) {
                <a class="dropdown-item" style="cursor:pointer;min-height: 20px;line-height: 20px;"
                  href="{{rl.url}}" target="_blank">
                  {{rl.displayText}}
                </a>
              }
            </ul>
          </li>
        }
      </ul>
      </div>
    </div>
  </div>
</nav>
